export class SegmentExtenderKeyframe {
  constructor(
    public width: number,
    public isKeyframe: boolean,
    public timeInMs?: number,
  ) {}
}
